/**
 * Workspace configuration — defines the 5 proposal role lenses.
 *
 * Each workspace controls: which tabs are visible, which tab is default,
 * what matrix filters are pre-applied, and a short description for the
 * switcher UI.
 *
 * These are NOT permission walls — any user can switch to any workspace.
 * They're productivity lenses that reduce noise for each role.
 */ export const WORKSPACES = {
    command: {
        id: 'command',
        label: 'Command',
        description: 'Full proposal health — for capture managers, proposal leads, and reviewers',
        icon: 'LayoutDashboard',
        defaultTab: 'overview',
        visibleTabs: [
            'overview',
            'matrix',
            'volumes',
            'people',
            'events',
            'gates',
            'activity'
        ]
    },
    author: {
        id: 'author',
        label: 'Author',
        description: 'Writing workspace — volume structure, format rules, page limits, assigned sections',
        icon: 'PenTool',
        defaultTab: 'volumes',
        visibleTabs: [
            'matrix',
            'volumes',
            'events'
        ]
    },
    pricing: {
        id: 'pricing',
        label: 'Pricing',
        description: 'Cost & staffing — CLINs, LCATs, key personnel, labor rates',
        icon: 'Calculator',
        defaultTab: 'volumes',
        visibleTabs: [
            'matrix',
            'volumes',
            'people'
        ]
    },
    compliance: {
        id: 'compliance',
        label: 'Compliance',
        description: 'Gates & legal — security clearances, OCI, bonds, contract type, subcontracting',
        icon: 'ShieldCheck',
        defaultTab: 'gates',
        visibleTabs: [
            'matrix',
            'gates',
            'activity'
        ]
    },
    references: {
        id: 'references',
        label: 'References',
        description: 'Past performance, orals prep, key personnel qualifications',
        icon: 'Award',
        defaultTab: 'people',
        visibleTabs: [
            'people',
            'events'
        ]
    }
};
export const WORKSPACE_LIST = Object.values(WORKSPACES);
/** Get stored workspace for a project, or default to 'command'. */ export function getStoredWorkspace(projectId) {
    try {
        const stored = localStorage.getItem(`workspace_${projectId}`);
        if (stored && stored in WORKSPACES) return stored;
    } catch  {
    /* localStorage unavailable */ }
    return 'command';
}
/** Persist workspace choice per project. */ export function storeWorkspace(projectId, workspace) {
    try {
        localStorage.setItem(`workspace_${projectId}`, workspace);
    } catch  {
    /* localStorage unavailable */ }
}
